import logExport from "./log/logExport";
export default {
    namespaced: true,
    modules: {
        logExport: logExport,       
    }
}
